import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import {
  IRefundedTransaction,
  RefundedTransaction,
} from '../../../../model/refunded-transaction';
import { IRefundedTransactionsApiService } from './refunded-transactions-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportRefundedTransactionsQueryDto } from './dtos/export-refunded-transactions.query.dto';
import { FindRefundedTransactionsQueryDto } from './dtos/find-refunded-transactions.query.dto';
import { FindRefundedTransactionsResponseDto } from './dtos/find-refunded-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class RefundedTransactionsMockApiService
  implements IRefundedTransactionsApiService
{
  data = {
    refunded_transactions: {
      items: [] as RefundedTransaction[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<IRefundedTransaction>,
      subject: new BehaviorSubject<Maybe<RefundedTransaction[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get refundedTransactionsData() {
    return this.data['refunded_transactions'] as Data<
      RefundedTransaction,
      IRefundedTransaction
    >;
  }

  findRefundedTransactions(query: FindRefundedTransactionsQueryDto): Promise<FindRefundedTransactionsResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportRefundedTransactions(query: ExportRefundedTransactionsQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
